import { IconNavigational24HomeIcon } from '@fabric-app/icons/svg';
import { useContextAccessToken } from '@fabric-app/business/permission/contexts/AnonShareTokenContext';
import { Button } from '@fabric-app/ui/components/Button';
import { useQueryUserInfo } from '@fabric-app/business/user/queries/useQueryUserInfo';
import { appRoutes } from '@fabric-app/business/app/routing/routes.config';
import { LinkTouch } from '@fabric-app/ui/components/Link/LinkTouch';

export const HomeButton = () => {
  const accessToken = useContextAccessToken();
  const { isAuthenticated } = useQueryUserInfo();
  return accessToken ? (
    <Button
      variant="bg-secondary"
      shape="square"
      as={LinkTouch}
      href={isAuthenticated ? appRoutes.home : appRoutes.auth.signin}
    >
      <IconNavigational24HomeIcon />
    </Button>
  ) : null;
};
